import { mutatorAction } from 'satcheljs';
import { RecentFilesList } from '../Schema/RecentFilesList';
import { getRecentFilesStore } from '../store/RecentFilesStore';
import { getRecentFilesList } from '../selectors/getRecentFilesList';

const updateRecentFilesStore = mutatorAction(
    'updateRecentFilesStore',
    function updateRecentFilesStore(groupSmtp: string, recentFilesList: RecentFilesList) {
        groupSmtp = groupSmtp.toLowerCase();
        const recentFilesStore = getRecentFilesStore();

        // Get the recent files list for the group, or a list with default values if group not found
        const currentRecentFilesList = getRecentFilesList(groupSmtp);

        currentRecentFilesList.fileItems = recentFilesList.fileItems;
        currentRecentFilesList.fileListLoadingStatus = recentFilesList.fileListLoadingStatus;
        currentRecentFilesList.filesHash = recentFilesList.filesHash;

        // Update or add new entry to the recent files list map
        recentFilesStore.recentFilesPerGroup.set(groupSmtp, currentRecentFilesList);
    }
);

export default updateRecentFilesStore;
